"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BackToTopButton = void 0;
var back_to_top_button_1 = require("./back-to-top-button");
Object.defineProperty(exports, "BackToTopButton", { enumerable: true, get: function () { return back_to_top_button_1.BackToTopButton; } });
